module.exports = __webpack_public_path__ + "media/images/display/lock-14fe33f58c1aaf543201370e3cfd0dc0.svg";